import styled from 'styled-components'
import { BsThreeDotsVertical } from 'react-icons/bs'

export const StyledTableContainer = styled.div`
    /* overflow-x: scroll; */
    margin-top: 4rem;
    padding: 2rem; 
    background-color: ${({ theme }) => theme.colors?.white};
    border: 1px solid rgba(33, 63, 125, 0.06);
    box-shadow: 3px 5px 20px rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    /* overflow: visible; */
    
    /* > div {
        &:first-child  {
            overflow: visible;
        }            
    } */
`
export const Dots = styled(BsThreeDotsVertical)`
   cursor: pointer;
   position: relative;
   padding: 10px;
   font-size: 38px;
   transition: all background ease-in-out;

   &:hover {
      background: #f3f1f3;
      border-radius: 50%;
   }
`;
export const StyledStatusPill = styled.div`
    border-radius: 10rem;
    background:  ${({ status }) => status === "inactive" ? "rgba(84, 95, 125, 0.1)" : status === "active" ? "rgba(57, 205, 98, 0.1)" : status === "blacklisted" ? "rgba(228, 3, 59, 0.1)" : "rgba(233, 178, 0, 0.1)"};
    font-size: 1.4rem;
    text-align: center;
    color:  ${({ status }) => status === "inactive" ? "rgba(84, 95, 125, 1)" : status === "active" ? "rgba(57, 205, 98, 1)" : status === "blacklisted" ? "rgba(228, 3, 59, 1)" : "rgba(233, 178, 0, 1)"};
    padding: 8px 1.6rem;
`;
export const StyledBackToUers = styled.div`
    display: flex;
    align-items: center;
    gap: 1.4rem;
    font-weight: 400;
    font-size: 1.6rem;
    color: ${({ theme }) => theme.colors?.grey};
`;
export const StyledUserDetailsHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 3.2rem;

    .main-header {
        font-weight: 500;
        font-size: 2.4rem;
        color: ${({ theme }) => theme.colors?.blue02};
    }

    @media(max-width: 600px) {
        flex-direction: column;
        gap: 2rem;
    }
`;
export const StyledButtonContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 2rem;

    @media(max-width: 600px) {
        flex-direction: column;
    }
    
`;
export const StyledUserDetailsTopSectionTabs = styled.div`
    margin-top: 4rem;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    overflow-x: scroll;
`;
export const StyledUserDetailsTopSectionTab = styled.div`
    padding: 1rem 0;
    text-align: center;
    font-weight: 400;
    font-size: 1.6rem;
    color: ${({ theme, active }) => active ? theme.colors?.green : "rgba(0, 0, 0, 0.8)"};
    border-bottom: ${({ theme, active }) => active ? `2px solid ${theme.colors?.green}` : "none"};
    width: 162px;

`;

export const StyledUserDetailsTopSection = styled.div`
    background-color: ${({ theme }) => theme.colors?.white};
    margin-top: 4rem;
    padding: 3rem 3rem 0 3rem;
    

    .general-details {
        display: flex;
        align-items: center;

        @media(max-width: 730px) {
            flex-direction: column;

            .border {
                width: 100% !important;
                height: 0 !important;
            }

            > div {
                padding: 3rem 0 !important;
                align-self: center !important;

                &:first-child  {
                    padding-top: 0 !important;
                }            
            }

            .user-tier-details, .user-account-details {
                text-align: center;
            }
        }

        .border {
            height: 8rem;
            opacity: 0.2;
            border: 1px solid ${({ theme }) => theme.colors?.grey};
        }

        > div {
            padding: 0 3rem;
            align-self: center;

            &:first-child  {
                padding-left: 0;
            }            
        }    

        .user-details {
            display: flex;
            align-items: center;
            gap: 2rem;

            .avatar {
                width: 10rem;
                height: 10rem;
                border-radius: 50%;
                background-color: rgba(33, 63, 125, 0.16);
                color: rgba(33, 63, 125, 1);
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .personal-info {
                .user-name {
                    font-weight: 500;
                    font-size: 2.2rem;
                    color: ${({ theme }) => theme.colors?.blue02};
                }

                .user-id {
                    font-weight: 400;
                    font-size: 1.4rem;
                    color: ${({ theme }) => theme.colors?.grey};
                }
            }
        }

        .user-tier-details {
            font-weight: 500;
            font-size: 1.4rem;
            color: ${({ theme }) => theme.colors?.grey};

            .ratings {
                color: ${({ theme }) => theme.colors?.yellow};
                margin-top: 1rem;
            }
        }

        .user-account-details {
            h2 {
                font-weight: 500;
                font-size: 2.2rem;
                color: ${({ theme }) => theme.colors?.blue02};
            }

            p{
                font-weight: 400;
                font-size: 1.2rem;
                color: ${({ theme }) => theme.colors?.blue02};
            }
        }
    }

    
`;